// ─────────────────────────────────────────────────────────────────────────────
// Bode-scoped palette — USED BY PROTOTYPE 05 ONLY.
//
// The Bode palette now also lives in theme/tokens.ts and applies app-wide.
// This module stays as tab 05's own layer: it holds the panel rule, the
// orchestration-column grounds and the forecast cone, and lets tab 05 diverge
// from the shared theme without touching the other tabs.
//
// Values read off bode-global.com — verify against the style guide PDF that
// J. Funk attached on 18 Sep.
// ─────────────────────────────────────────────────────────────────────────────

import { colors as base } from './tokens';

/** Raw brand values. Placeholders until the Bode style guide is in hand. */
const BODE = {
  /** Primary brand colour — structure, headings, active state. Logo blue. */
  primary: '#4456F2',
  /** Darker step for hover / pressed / deep fills. */
  primaryDeep: '#2E3ECC',
  /** Accent — rules, selection, emphasis. Bode lime. */
  accent: '#D2FF75',
  /** Ink for headings and primary text. Bode navy. */
  ink: '#0B0D48',
} as const;

/** True once real Bode values are in place. */
export const BODE_BRANDED = true;

export const bode = {
  ...base,

  // Brand-driven overrides. Structural, so swapping BODE above reskins the tab.
  blue: BODE.primary,
  blueDeep: BODE.primaryDeep,
  accent: BODE.accent,
  ink: BODE.ink,

  /** Panel rule — brand-led on this tab, hairline elsewhere. */
  rule: BODE.primary,
  /** Ground for the orchestration column, separating it from the stats. */
  agentGround: base.blueWash,
  agentBorder: base.blueSoft,
} as const;

/** Forecast cone — one hue, light→dark. Never a second series colour. */
export const cone = {
  band: base.blueSoft,
  bandEdge: base.blueMid,
  line: BODE.primary,
  lineDashed: base.blueMid,
} as const;
